import React from 'react';
import { useTranslation } from 'react-i18next';
import { CustomTextField } from '../../../../../components/CustomTextField';
import ButtonIcon from '../../../../../components/buttons/ButtonIcon';
import { CleanIcon } from '../../../../../components/buttons/IconButtons';

const Step2OtherDetails = ({ extraData, onChange, headersList, profile, handleClearExtraData, disable, showBtnClean }) => {
    const { t } = useTranslation();
    
    return (
        <div className={'row mt-4'}>
            { !showBtnClean?.id && (
                <div className='col-12 d-flex justify-content-end mb-2'>
                    <ButtonIcon
                        className='btn-clean-secondary-600'
                        id='btn_s2od_clean_form'
                        Icon={CleanIcon}
                        title={'clear_instances'}
                        onClick={() => {
                            handleClearExtraData();
                        }}
                        iconProps={'btn-icon-svg-12px icon-color-general-00'}
                    />
                </div>
            )}
            <div className='col-sm-12 col-xxl-6 col-lg-6'>
                <CustomTextField
                    id={'txt_s2od_header1'}
                    length={128}
                    name={'field1'}
                    value={extraData.field1}
                    trans={headersList?.header1 || 'header_1'}
                    type={'text'}
                    onChange={onChange}
                    disabled={disable}
                />
            </div>
            <div className='col-sm-12 col-xxl-6 col-lg-6'>
                <CustomTextField
                    id={'txt_s2od_header2'}
                    length={128}
                    name={'field2'}
                    value={extraData.field2}
                    trans={headersList?.header2 || 'header_2'}
                    type={'text'}
                    onChange={onChange}
                    disabled={disable}
                />
            </div>
            <div className='col-sm-12 col-xxl-6 col-lg-6'>
                <CustomTextField
                    id={'txt_s2od_header3'}
                    length={128}
                    name={'field3'}
                    value={extraData.field3}
                    trans={headersList?.header3 || 'header_3'}
                    type={'text'}
                    onChange={onChange}
                    disabled={disable}
                />
            </div>
            <div className='col-sm-12 col-xxl-6 col-lg-6'>
                <CustomTextField
                    id={'txt_s2od_header4'}
                    length={128}
                    name={'field4'}
                    value={extraData.field4}
                    trans={headersList?.header4 || 'header_4'}
                    type={'text'}
                    onChange={onChange}
                    disabled={disable}
                />
            </div>
            <div className='col-sm-12 col-xxl-6 col-lg-6'>
                <CustomTextField
                    id={'txt_s2od_header5'}
                    length={128}
                    name={'field5'}
                    value={extraData.field5}
                    trans={headersList?.header5 || 'header_5'}
                    type={'text'}
                    onChange={onChange}
                    disabled={disable}
                />
            </div>
            <div className='col-sm-12 col-xxl-6 col-lg-6'>
                <CustomTextField
                    id={'txt_s2od_header6'}
                    length={128}
                    name={'field6'}
                    value={extraData.field6}
                    trans={headersList?.header6 || 'header_6'}
                    type={'text'}
                    onChange={onChange}
                    disabled={disable}
                />
            </div>
            <div className='col-sm-12 col-xxl-6 col-lg-6'>
                <CustomTextField
                    id={'txt_s2od_header7'}
                    length={128}
                    name={'field7'}
                    value={extraData.field7}
                    trans={headersList?.header7 || 'header_7'}
                    type={'text'}
                    onChange={onChange}
                    disabled={disable}
                />
            </div>
            <div className='col-sm-12 col-xxl-6 col-lg-6'>
                <CustomTextField
                    id={'txt_s2od_header8'}
                    length={128}
                    name={'field8'}
                    value={extraData.field8}
                    trans={headersList?.header8 || 'header_8'}
                    type={'text'}
                    onChange={onChange}
                    disabled={disable}
                />
            </div>
            <div className='col-sm-12 col-xxl-6 col-lg-6'>
                <CustomTextField
                    id={'txt_s2od_header9'}
                    length={128}
                    name={'field9'}
                    value={extraData.field9}
                    trans={headersList?.header9 || 'header_9'}
                    type={'text'}
                    onChange={onChange}
                    disabled={disable}
                />
            </div>
            <div className='col-sm-12 col-xxl-6 col-lg-6'>
                <CustomTextField
                    id={'txt_s2od_header10'}
                    length={128}
                    name={'field10'}
                    value={extraData.field10}
                    trans={headersList?.header10 || 'header_10'}
                    type={'text'}
                    onChange={onChange}
                    disabled={disable}
                />
            </div>
            <div className='col-sm-12 col-xxl-6 col-lg-6'>
                <CustomTextField
                    id={'txt_s2od_header11'}
                    length={128}
                    name={'field11'}
                    value={extraData.field11}
                    trans={headersList?.header11 || 'header11'}
                    type={'text'}
                    onChange={onChange}
                    disabled={disable}
                />
            </div>
            <div className='col-sm-12 col-xxl-6 col-lg-6'>
                <CustomTextField
                    id={'txt_s2od_header12'}
                    length={128}
                    name={'field12'}
                    value={extraData.field12}
                    trans={headersList?.header12 || 'header_12'}
                    type={'text'}
                    onChange={onChange}
                    disabled={disable}
                />
            </div>
            <div className='col-sm-12 col-xxl-6 col-lg-6'>
                <CustomTextField
                    id={'txt_s2od_header13'}
                    length={128}
                    name={'field13'}
                    value={extraData.field13}
                    trans={headersList?.header13 || 'header_13'}
                    type={'text'}
                    onChange={onChange}
                    disabled={disable}
                />
            </div>
            <div className='col-sm-12 col-xxl-6 col-lg-6'>
                <CustomTextField
                    id={'txt_s2od_header14'}
                    length={128}
                    name={'field14'}
                    value={extraData.field14}
                    trans={headersList?.header14 || 'header_14'}
                    type={'text'}
                    onChange={onChange}
                    disabled={disable}
                />
            </div>
            <div className='col-sm-12 col-xxl-6 col-lg-6'>
                <CustomTextField
                    id={'txt_s2od_header15'}
                    length={128}
                    name={'field15'}
                    value={extraData.field15}
                    trans={headersList?.header15 || 'header_15'}
                    type={'text'}
                    onChange={onChange}
                    disabled={disable}
                />
            </div>
        </div>
    );
};

export default Step2OtherDetails;
